import * as React from "react";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { ArtifactAcceptabilityIds } from "./PFTAPITypes";
import { faCheck, faCircle, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Permission, AnalysisSet } from "../../misc/api/apiTypes";
import { DlcoAnalysisSet, FvcAnalysisSet, SvcAnalysisSet, LungVolumeAnalysisSet, PefAnalysisSet, OscillometryAnalysisSet } from "webportalclient";

import { useNavigate } from 'react-router-dom';

export type UseHistoryType = ReturnType<typeof useNavigate>;

export const GoBackToList = (navigate: UseHistoryType, currentUserPermissions: Permission[], sessionListRoute: string, analysisPermission: PermissionEnum, analysisListRoute: string) => {
    currentUserPermissions.map(p => p.Id).includes(analysisPermission)  ? navigate(analysisListRoute) : navigate(sessionListRoute);
}

export const createFormatters = <T extends DlcoAnalysisSet | FvcAnalysisSet | SvcAnalysisSet | LungVolumeAnalysisSet | PefAnalysisSet | OscillometryAnalysisSet>(
    isQcAnalysisSet: (set: T) => boolean
) => {
    const formatValue = (getter: (set: T) => string) => (set: T) =>
        isQcAnalysisSet(set) ? "-" : getter(set);

    return {
        formatSiteId: formatValue(set => set.session.visit.subject.site.number),
        formatSubjectId: formatValue(set => set.session.visit.subject.number),
        formatSubjectType: formatValue(set => set.session.visit.subject.typeName),
        formatVisitLabel: formatValue(set => set.session.visit.name),
        formatSessionLabel: formatValue(set => set.session.name),
    };
};

export const QualityAcceptability = ({ artifact }) => {
    switch (artifact) {
        case ArtifactAcceptabilityIds.Undetermined:
            return <i aria-hidden="true" title="Undetermined">-</i>
        case ArtifactAcceptabilityIds.Acceptable:
            return <FontAwesomeIcon icon={faCheck} className="text-success" aria-hidden="true" title="Acceptable" />
        case ArtifactAcceptabilityIds.Usable:
            return <FontAwesomeIcon icon={faCircle} className="text-warning" aria-hidden="true" title="Usable" />
        case ArtifactAcceptabilityIds.NotAcceptable:
            return <FontAwesomeIcon icon={faXmark} className="text-danger" aria-hidden="true" title="Not Acceptable" />
        default:
            return null;
    }
}
